import React from 'react';


const MachinesComponent = () => {
  const machine ="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Roots+and+Wings%2C+3lens+and+LSG/Powered+by+Machines.png";
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Image side */}
          <div className="w-full md:w-2/5">
            <img 
              src={machine} 
              alt="AI/Machine Learning" 
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
          
          {/* Content side */}
          <div className="w-full md:w-3/5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">Powered by Machines</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-4">AI-Driven. Human-Guided. Consistently Optimised.</h3>
            
            <p className="text-gray-700 mb-4">
              Our equity research is powered by advanced machine learning algorithms.
              We analyse thousands of financial data points from listed companies, simulate millions 
              of scenarios, and evaluate macro-environment impacts.
            </p>
            
            <p className="text-gray-700 mb-3">What sets us apart:</p>
            
            <ul className="mb-4 space-y-2">
              {[
                'AI-powered portfolio construction based on rule-based heuristics',
                'Neural networks that identify sector trends, earnings strength, and stock behaviour',
                'Optimised portfolios tested for low drawdowns and faster recoveries'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <p className="text-gray-700">
              This allows us to scale our Roots & Wings process efficiently—delivering 
              portfolios that are data-informed and future-ready.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MachinesComponent;